export enum FileType {
    Image = 'image',
    Video = 'video',
    Audio = 'audio',
    Pdf = 'pdf',
    Docx = 'docx',
    Other = 'other'
}
